<template>

  <v-card color="" tile elevation="10">
    <v-card-title class="title font-weight-regular justify-space-between">

      <span>{{ $t("login.title") }}</span>

      <v-avatar
          color="primary"
          class="subheading white--text"
          size="40">
        <v-icon dark>
          mdi-account-lock
        </v-icon>
      </v-avatar>

    </v-card-title>

    <validation-observer
        ref="observer"
        v-slot="{ invalid }">
      <v-form @submit.prevent="submit">
        <v-card-text>
          <validation-provider
              v-slot="{ errors }"
              name="username"
              rules="required|email">
            <v-text-field
                v-model="email"
                v-bind:label="$t('login.email_input')"
                value=""
                required
                :error-messages="errors"
            >
            </v-text-field>
          </validation-provider>

          <validation-provider
              v-slot="{ errors }"
              name="password"
              rules="required">
            <v-text-field
                v-model="password"
                v-bind:label="$t('login.password_input')"
                value=""
                type="password"
                required
                :error-messages="errors"
                v-on:keyup.enter="submit"
            >
            </v-text-field>
          </validation-provider>

          <span v-if="error" v-bind="error" class="red--text">
                {{ error }}
              </span>

        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-row>
            <v-col class="text-center" cols="6">
              <v-btn color="secondary"
                     @click="$router.push({name:'Register'})"
              >
                {{ $t('login.register_button') }}
              </v-btn>
            </v-col>
            <v-col class="text-center" cols="6">
              <div>
                <v-progress-circular
                    indeterminate
                    color="primary"
                    v-if="is_loading">
                </v-progress-circular>
                <v-btn
                    v-else
                    color="primary"
                    depressed
                    type="submit"
                    :disabled="invalid">
                  {{ $t('login.login_button') }}
                </v-btn>
              </div>
            </v-col>
            <v-col cols="12">
              <v-divider/>
            </v-col>
            <v-col cols="12">
              <v-btn link :href="'/if/'+$route.params.lang+'/submission'" block color="primary">
                Submit Via FilmFreeWay
              </v-btn>
            </v-col>

          </v-row>


        </v-card-actions>
        <v-divider></v-divider>
      </v-form>
    </validation-observer>

  </v-card>

</template>

<script>
import {ValidationObserver, ValidationProvider, setInteractionMode, extend} from 'vee-validate';
import {required, email} from 'vee-validate/dist/rules'
import axios from "axios";
import FormData from "form-data";
import i18n from "../i18n";

setInteractionMode('eager');

extend('required', {
  ...required,
  message: () => i18n.t('login.required')
})
extend('email', {
  ...email,
  message: () => i18n.t('login.phone_number_format_error')
})


export default {
  name: "login",
  data: () => ({
    email: '',
    password: '',
    loading: false,
    error: ''
  }),
  methods: {
    submit() {
      this.$refs.observer.validate()
      let data = new FormData();
      data.append('email', this.email);
      data.append('password', this.password);

      let config = {
        method: 'post',
        url: this.$store.state.base_url + '/auth/login/',
        data: data
      };
      let context = this
      this.loading = true
      axios(config)
          .then((response) => {
            localStorage.setItem('token', response.data.token)
            context.$router.push('/' + context.$route.params.lang)
            context.loading = false
          })
          .catch((err) => {
            console.log("not input")
            if (err.response.status === 400) {
              context.error = context.$t('login.wrong_username_or_password')
            } else {
              context.error = i18n.t('token_login.message_error')
            }
            context.loading = false
          });
    }
  },


  computed: {
    is_loading() {
      return this.loading
    },

  },
  components: {
    ValidationProvider,
    ValidationObserver,
  }

}
</script>

